import type { Relays } from '../../types.ts';

import type {ServerWebSocketHandler} from '@interopio/gateway-server/web/server';
import {IOGateway} from '@interopio/gateway';

let handlerId = 0;
async function create(log: IOGateway.Logging.Logger,
                      internal: Relays,
                      env: { endpoint: string }): Promise<ServerWebSocketHandler> {

    const id = ++handlerId;
    log.info(`relays-${id} server is listening on ${env.endpoint}`);
    let keyId = 0;
    return async ({socket, handshake}) => {
        const logPrefix = handshake.logPrefix ?? '';
        const query = handshake.url.searchParams;
        const key = `r.${id}.${++keyId}`
        log.info(`${logPrefix}connected on /relays with ${query} and assigned key ${key}`);
        internal.add(key, (msg: string, c, cb) => {
            socket.send(msg, {binary: false}, (err?: Error) => {
                cb(key, err);
            });
        });
        //onOpen(connectedNodes, key);
        socket.on('error', (err: Error) => {
            log.error(`${logPrefix}websocket error: ${err.message}`, err);
        });
        socket.on('message', (data, _isBinary) => {
            if (Array.isArray(data)) {
                data = Buffer.concat(data);
            }
            try {
                internal.receive(key, data as unknown as string);
            } catch (e) {
                log.warn(`${logPrefix}error processing received data '${data}'`, e);
            }
        });
        socket.on('close', (code, reason) => {
            internal.remove(key);

            log.info(`${logPrefix}disconnected from relays (code: ${code}, reason: '${reason.toString('utf8')}')`);
        });
    };
}

export const meshRelays = ({logger, relays}: { logger: IOGateway.Logging.Logger, relays: Relays }) => {
    return async (env: { endpoint: string }) => {
        return await create(logger, relays, env);
    }
}
